import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideBar from "../Form&Bars/SideBar";
import Header from "../Form&Bars/Header";

const MainLayout = () => {
    const location = useLocation();
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: "auto",
            });
        }
    }, [location.pathname]);

    return (
        <div className="flex h-screen bg-gray-950 overflow-hidden">
            <SideBar />
            <div className="flex-1 flex flex-col min-w-0">
                <Header />
                <main
                    ref={scrollContainerRef}
                    className="flex-1 overflow-y-auto overflow-x-hidden"
                >
                    <div key={location.pathname} className="route-transition">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout;